import { get, isMockMode, simulateDelay } from "../api";

export const getOrgSummaries = () => {
	if (isMockMode()) {
		const testData = {
			totalAvailable: 10,
			fetchedCount: 10,
			skippedCount: 0,
			results: [
				{
					isProductOwnerEnabled: true,
					isServiceOwnerEnabled: true,
					isDeleted: false,
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					name: "Test Name",
				},
				{
					isProductOwnerEnabled: false,
					isServiceOwnerEnabled: false,
					isDeleted: false,
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					name: "Test Name",
				},
				{
					isProductOwnerEnabled: false,
					isServiceOwnerEnabled: false,
					isDeleted: false,
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					name: "Test Name",
				},
				{
					isProductOwnerEnabled: false,
					isServiceOwnerEnabled: false,
					isDeleted: false,
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					name: "Test Name",
				},
				{
					isProductOwnerEnabled: false,
					isServiceOwnerEnabled: false,
					isDeleted: false,
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					name: "Test Name",
				},
				{
					isProductOwnerEnabled: false,
					isServiceOwnerEnabled: false,
					isDeleted: false,
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					name: "Test Name",
				},
				{
					isProductOwnerEnabled: false,
					isServiceOwnerEnabled: false,
					isDeleted: true,
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					name: "Test Name",
				},
			],
		};
		return simulateDelay(50, () => testData);
	}

	return get(`sysadmin/getorgsummaries?includeDeleted=true`);
};
